import { Container } from '@react-email/components';

const container = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Container
                onMouseDown={e => e.stopPropagation()}
                {...attributes}
                {...element.attributes}
            >
                {children}
            </Container>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return <Container {...attributes}>{children}</Container>;
    },
};

export default container;
